module.exports = __webpack_public_path__ + "static/img/philips.ee0c518a.png";